import { Link } from "react-router-dom";

export const CTAS = [
  { label: "Find Care", to: "/in-home-care#care-questionnaire", cls: "btn-primary", id: "find-care" },
  { label: "Explore Housing", to: "/housing", cls: "btn-accent", id: "explore-housing" },
  { label: "Join Our Team", to: "/careers", cls: "btn-outline", id: "join-our-team" },
  { label: "Partner With Us", to: "/partner-with-us", cls: "btn-outline", id: "partner-with-us" },
];

export const CtaGroup = ({ prefix = "hero", exclude = [], overrides = {} }) => (
  <div className="flex flex-wrap gap-2.5 [&>a]:px-5">
    {CTAS.filter((c) => !exclude.includes(c.id)).map((c) => (
      <Link key={c.id} to={overrides[c.id]?.to || c.to} className={`btn-pill ${c.cls}`} data-testid={`${prefix}-${c.id}-cta-button`}>
        {overrides[c.id]?.label || c.label}
      </Link>
    ))}
  </div>
);

export const CtaBand = ({ title = "Tell us what support you are looking for.", text, prefix = "band", children }) => (
  <section className="container-site py-16 sm:py-24">
    <div className="relative overflow-hidden rounded-[2rem] bg-[#F3EFEA] border border-[#E5E0D8] p-8 sm:p-14 grid lg:grid-cols-12 gap-8 items-center">
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#C86D51]/10" aria-hidden="true" />
      <div className="lg:col-span-7 relative">
        <span className="eyebrow">Start a conversation</span>
        <h2 className="h2">{title}</h2>
        <p className="lead mt-4">{text || "Whether you are arranging care, looking for stable housing, applying to join our care team or exploring a partnership, we will review your inquiry and follow up personally."}</p>
      </div>
      <div className="lg:col-span-5 relative">{children || <CtaGroup prefix={prefix} />}</div>
    </div>
  </section>
);
